/* Razvan Garage – wishlist propriu.
   Lista (id-uri de produs) stă în browser; pagina /pages/wishlist ia datele produselor din Storefront API. */
(() => {
  if (window.RGWishlistLoaded) return;
  window.RGWishlistLoaded = true;

  const cfg = window.RGWishlist || {};
  const KEY = 'rg-wishlist';
  const MAX = 120;   // atât încape și în lista din contul clientului
  const SHARE_MAX = 150;
  const HEART = '<svg class="rg-wl__icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  const validId = (id) => Number.isSafeInteger(id) && id > 0;

  // ---------- lista ----------
  let cache = null;
  const list = {
    ids() {
      if (cache) return cache;
      try {
        const saved = JSON.parse(localStorage.getItem(KEY));
        cache = Array.isArray(saved) ? saved.filter(validId) : [];
      } catch (error) {
        cache = [];
      }
      return cache;
    },
    save(ids) {
      cache = [...new Set(ids.filter(validId))].slice(0, MAX);
      try {
        localStorage.setItem(KEY, JSON.stringify(cache));
      } catch (error) {
        // navigare privată sau spațiu plin: lista rămâne doar pentru pagina curentă
      }
      document.dispatchEvent(new CustomEvent('rg-wishlist:change'));
    },
    has(id) {
      return this.ids().includes(id);
    },
    toggle(id) {
      const on = !this.has(id);
      this.save(on ? [id, ...this.ids()] : this.ids().filter((other) => other !== id));
      account.queue([{op: on ? 'add' : 'remove', id}]);
      return on;
    },
    add(ids) {
      const fresh = ids.filter((id) => !this.has(id));
      this.save([...fresh, ...this.ids()]);
      account.queue(fresh.map((id) => ({op: 'add', id})));
    },
    remove(ids) {
      this.save(this.ids().filter((id) => !ids.includes(id)));
      account.queue(ids.map((id) => ({op: 'remove', id})));
    }
  };

  window.addEventListener('storage', (event) => {
    if (event.key !== KEY) return;
    cache = null;
    document.dispatchEvent(new CustomEvent('rg-wishlist:change'));
  });

  // ---------- contul clientului ----------
  // Clientul logat are lista și în Shopify (prin /apps/rg-wishlist). Browserul ține o copie și coada de
  // schimbări netrimise; la prima logare lista din browser se unește cu cea din cont.
  const ACCOUNT_KEY = 'rg-wishlist-cont';
  const account = {
    busy: false,
    state() {
      try {
        const saved = JSON.parse(localStorage.getItem(ACCOUNT_KEY));
        if (saved && typeof saved === 'object') {
          return {client: saved.client || null, queue: Array.isArray(saved.queue) ? saved.queue : [], last: saved.last || 0};
        }
      } catch (error) {
        // stare stricată: se pornește de la zero
      }
      return {client: null, queue: [], last: 0};
    },
    store(state) {
      try {
        localStorage.setItem(ACCOUNT_KEY, JSON.stringify(state));
      } catch (error) {
        // fără stocare locală nu se ține coada; lista din cont rămâne cea bună
      }
    },
    queue(ops) {
      if (!cfg.customerId || !cfg.proxyUrl || !ops.length) return;
      const state = this.state();
      if (state.client !== cfg.customerId) return;   // încă neunită: totul pleacă la prima unire
      state.queue.push(...ops);
      this.store(state);
      this.sync();
    },
    // force: cere lista din cont chiar dacă a fost luată în ultimul minut (pagina de wishlist)
    async sync(force) {
      if (!cfg.customerId || !cfg.proxyUrl || this.busy) return;
      const state = this.state();
      const first = state.client !== cfg.customerId;
      if (!first && !state.queue.length && !force && Date.now() - state.last < 60000) return;
      this.busy = true;
      const sent = first ? [] : state.queue.slice();
      const local = list.ids().slice();
      let more = false;
      try {
        const response = await fetch(cfg.proxyUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(first ? {merge: local} : {ops: sent})
        });
        const result = response.ok ? await response.json() : null;
        if (result && result.ok && result.logat && Array.isArray(result.ids)) {
          // ce s-a apăsat cât a durat cererea rămâne în coadă și se aplică peste răspuns
          const now = list.ids();
          const rest = first
            ? [...now.filter((id) => !local.includes(id)).map((id) => ({op: 'add', id})),
              ...local.filter((id) => !now.includes(id)).map((id) => ({op: 'remove', id}))]
            : this.state().queue.slice(sent.length);
          let ids = result.ids.map(Number).filter(validId);
          for (const change of rest) {
            ids = ids.filter((id) => id !== change.id);
            if (change.op === 'add') ids.unshift(change.id);
          }
          this.store({client: cfg.customerId, queue: rest, last: Date.now()});
          if (ids.join() !== list.ids().join()) list.save(ids);
          more = rest.length > 0;
        }
      } catch (error) {
        // serverul nu răspunde: schimbările rămân în coadă și pleacă la pagina următoare
      }
      this.busy = false;
      if (more) this.sync();
    }
  };

  // ---------- inimioara (carduri și pagina produsului) ----------
  if (!customElements.get('rg-wishlist-button')) {
    customElements.define('rg-wishlist-button', class extends HTMLElement {
      connectedCallback() {
        this.productId = Number(this.dataset.productId);
        if (!validId(this.productId)) return;
        if (!this.button) {
          const text = this.classList.contains('rg-wl--product') ? '<span class="rg-wl__text"></span>' : '';
          this.innerHTML = `<button type="button" class="rg-wl__btn">${HEART}${text}</button>`;
          this.button = this.firstElementChild;
          this.button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.button.classList.toggle('rg-wl__btn--pop', list.toggle(this.productId));
          });
          this.render = this.render.bind(this);
        }
        document.addEventListener('rg-wishlist:change', this.render);
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('rg-wishlist:change', this.render);
      }

      render() {
        const on = list.has(this.productId);
        const label = on ? 'Scoate din wishlist' : 'Adaugă în wishlist';
        this.button.setAttribute('aria-pressed', String(on));
        const text = this.button.querySelector('.rg-wl__text');
        if (text) {
          text.textContent = on ? 'Salvat în wishlist' : label;
        } else {
          this.button.setAttribute('aria-label', label);
          this.button.title = label;
        }
      }
    });
  }

  // ---------- numărul din antet ----------
  const renderCount = () => {
    const count = list.ids().length;
    document.querySelectorAll('[data-rg-wl-count]').forEach((bubble) => {
      bubble.hidden = count === 0;
      const number = bubble.querySelector('[data-rg-wl-number]');
      if (number) number.textContent = count > 99 ? '99+' : String(count);
      const spoken = bubble.querySelector('[data-rg-wl-spoken]');
      if (spoken) spoken.textContent = count === 1 ? '1 produs în wishlist' : `${count} produse în wishlist`;
    });
  };
  document.addEventListener('rg-wishlist:change', renderCount);
  renderCount();

  // ---------- pagina /pages/wishlist ----------
  const QUERY = `query RGWishlist($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id handle title vendor availableForSale
        featuredImage { url(transform: {maxWidth: 480, maxHeight: 480}) altText }
        variants(first: 2) { nodes { id availableForSale price { amount } compareAtPrice { amount } } }
      }
    }
  }`;

  const escapeHtml = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (char) => (
    {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[char]
  ));

  const money = (amount) => {
    const parts = (decimals, thousands, comma) => {
      const [whole, fraction] = Number(amount).toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? comma + fraction : '');
    };
    const formats = {
      amount: () => parts(2, ',', '.'),
      amount_no_decimals: () => parts(0, ',', '.'),
      amount_with_comma_separator: () => parts(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => parts(0, '.', ','),
      amount_with_apostrophe_separator: () => parts(2, "'", '.')
    };
    const format = String(cfg.moneyFormat || '').replace(/<[^>]*>/g, '');
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return parts(2, '.', ',') + ' lei';
    return format.replace(match[0], (formats[match[1]] || formats.amount_with_comma_separator)());
  };

  // Întoarce Map(id -> produs sau null dacă produsul nu mai există / nu mai e publicat).
  const fetchProducts = async (ids) => {
    const found = new Map();
    for (let start = 0; start < ids.length; start += 25) {
      const chunk = ids.slice(start, start + 25);
      const response = await fetch(cfg.apiUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({query: QUERY, variables: {ids: chunk.map((id) => `gid://shopify/Product/${id}`)}})
      });
      if (!response.ok) throw new Error(`Storefront API ${response.status}`);
      const result = await response.json();
      if (result.errors || !result.data || !Array.isArray(result.data.nodes)) throw new Error('Storefront API');
      chunk.forEach((id, index) => {
        const node = result.data.nodes[index];
        found.set(id, node && node.handle ? node : null);
      });
    }
    return found;
  };

  const cardHtml = (id, product, shared) => {
    const url = `/products/${encodeURIComponent(product.handle)}`;
    const variants = product.variants.nodes;
    const variant = variants.find((item) => item.availableForSale) || variants[0];
    const price = variant ? Number(variant.price.amount) : 0;
    const was = variant && variant.compareAtPrice ? Number(variant.compareAtPrice.amount) : 0;
    const sale = was > price;
    const image = product.featuredImage
      ? `<img src="${escapeHtml(product.featuredImage.url)}" alt="${escapeHtml(product.featuredImage.altText || product.title)}" width="480" height="480" loading="lazy" decoding="async">`
      : '';
    const corner = shared
      ? `<rg-wishlist-button class="rg-wl rg-wl--card" data-product-id="${id}"></rg-wishlist-button>`
      : '<button type="button" class="rg-wlp-card__remove" data-rg-wlp-remove aria-label="Scoate din listă" title="Scoate din listă">&times;</button>';
    let buy;
    if (!product.availableForSale || !variant) {
      buy = '<button type="button" class="btn btn--primary w-full" disabled>Stoc epuizat</button>';
    } else if (variants.length > 1) {
      buy = `<a class="btn btn--primary w-full" href="${url}">Alege opțiunile</a>`;
    } else {
      buy = `<product-form>
        <div class="alert mb-4 bg-error-bg text-error-text js-form-error text-start" role="alert" hidden></div>
        <form method="post" action="${escapeHtml(cfg.cartAddUrl || '/cart/add')}" class="js-product-form" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="id" value="${escapeHtml(variant.id.split('/').pop())}">
          <button class="btn btn--primary w-full" name="add" aria-haspopup="dialog">Adaugă în coș</button>
        </form>
      </product-form>`;
    }
    return `<article class="rg-wlp-card" data-id="${id}">
      ${corner}
      <a class="rg-wlp-card__media" href="${url}" tabindex="-1" aria-hidden="true">${image}</a>
      <div class="rg-wlp-card__info">
        <span class="rg-wlp-card__vendor">${escapeHtml(product.vendor)}</span>
        <a class="rg-wlp-card__title" href="${url}">${escapeHtml(product.title)}</a>
        <div class="rg-wlp-card__price">
          <span class="rg-wlp-card__now${sale ? ' rg-wlp-card__now--sale' : ''}">${variants.length > 1 ? 'de la ' : ''}${escapeHtml(money(price))}</span>
          ${sale ? `<s class="rg-wlp-card__was">${escapeHtml(money(was))}</s>` : ''}
        </div>
      </div>
      <div class="rg-wlp-card__buy">${buy}</div>
    </article>`;
  };

  if (!customElements.get('rg-wishlist-page')) {
    customElements.define('rg-wishlist-page', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.grid = this.querySelector('[data-rg-wlp-grid]');
        const param = new URLSearchParams(window.location.search).get('l');
        const sharedIds = param ? [...new Set(param.split('.').map((part) => parseInt(part, 36)).filter(validId))].slice(0, SHARE_MAX) : [];
        this.sharedIds = sharedIds.length ? sharedIds : null;
        this.classList.toggle('rg-wlp--shared', Boolean(this.sharedIds));

        this.querySelector('[data-rg-wlp-share]').addEventListener('click', () => this.share());
        this.querySelector('[data-rg-wlp-save]').addEventListener('click', () => {
          list.add(this.shown);
          this.toast('Produsele au fost salvate în lista ta.');
        });
        this.querySelector('[data-rg-wlp-retry]').addEventListener('click', () => this.load());
        this.grid.addEventListener('click', (event) => {
          const remove = event.target.closest('[data-rg-wlp-remove]');
          if (remove) list.remove([Number(remove.closest('[data-id]').dataset.id)]);
        });
        document.addEventListener('rg-wishlist:change', () => this.sync());
        this.shown = [];
        this.load();
      }

      state(name) {
        this.dataset.state = name;
        for (const part of ['loading', 'empty', 'error']) {
          this.querySelector(`[data-rg-wlp-${part}]`).hidden = part !== name;
        }
        this.grid.hidden = name !== 'list';
        this.querySelector('[data-rg-wlp-share]').hidden = name !== 'list';
        this.querySelector('[data-rg-wlp-save]').hidden = name !== 'list' || !this.sharedIds;
        this.querySelector('[data-rg-wlp-mine]').hidden = !this.sharedIds;
        const count = this.shown.length;
        const products = count === 1 ? '1 produs' : `${count} produse`;
        let sub = '';
        if (name === 'list') sub = this.sharedIds ? `Listă primită · ${products}` : products;
        if (name === 'empty' && this.sharedIds) sub = 'Produsele din lista primită nu mai sunt disponibile.';
        this.querySelector('[data-rg-wlp-sub]').textContent = sub;
        this.querySelector('[data-rg-wlp-empty-text]').hidden = Boolean(this.sharedIds);
      }

      async load() {
        const ids = this.sharedIds || list.ids();
        this.shown = [];
        if (!ids.length) {
          this.grid.innerHTML = '';
          this.state('empty');
          return;
        }
        this.state('loading');
        const run = this.run = Symbol('load');
        try {
          const products = await fetchProducts(ids);
          if (run !== this.run) return;
          this.shown = ids.filter((id) => products.get(id));
          this.grid.innerHTML = this.shown.map((id) => cardHtml(id, products.get(id), Boolean(this.sharedIds))).join('');
          this.state(this.shown.length ? 'list' : 'empty');
          // produsele șterse sau scoase de pe site ies singure din lista proprie
          if (!this.sharedIds && this.shown.length < ids.length) list.remove(ids.filter((id) => !this.shown.includes(id)));
        } catch (error) {
          if (run === this.run) this.state('error');
        }
      }

      // Lista s-a schimbat (aici sau în altă filă): scot cardurile dispărute, reîncarc dacă au apărut altele.
      sync() {
        if (this.sharedIds || this.dataset.state === 'loading') return;
        const ids = list.ids();
        if (ids.some((id) => !this.shown.includes(id))) {
          this.load();
          return;
        }
        this.shown = this.shown.filter((id) => ids.includes(id));
        this.grid.querySelectorAll('[data-id]').forEach((card) => {
          if (!ids.includes(Number(card.dataset.id))) card.remove();
        });
        this.state(this.shown.length ? 'list' : 'empty');
      }

      async share() {
        const code = this.shown.slice(0, SHARE_MAX).map((id) => id.toString(36)).join('.');
        const url = `${window.location.origin}${cfg.pageUrl || window.location.pathname}?l=${code}`;
        if (navigator.share) {
          try {
            await navigator.share({title: 'Lista mea de dorințe – Razvan Garage', url});
            return;
          } catch (error) {
            if (error.name === 'AbortError') return;
          }
        }
        try {
          await navigator.clipboard.writeText(url);
          this.toast('Linkul listei a fost copiat. Îl poți trimite oricui.');
        } catch (error) {
          const field = this.querySelector('[data-rg-wlp-link]');
          field.value = url;
          field.hidden = false;
          field.focus();
          field.select();
        }
      }

      toast(message) {
        const box = this.querySelector('[data-rg-wlp-toast]');
        box.textContent = message;
        box.hidden = false;
        clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => { box.hidden = true; }, 3500);
      }
    });
  }

  // ---------- pornire: lista din cont ----------
  if (cfg.customerId) {
    account.sync(Boolean(document.querySelector('rg-wishlist-page')));
  } else if (account.state().client) {
    account.store({client: null, queue: [], last: 0});   // s-a delogat: lista rămâne în browser, ca la un vizitator
  }
})();
